import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button } from '@mui/material'
import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyles from 'shared/hooks/useStyle'

import Loading from 'shared/Loading'

import { useLocationContext } from '../Location'
import useReadyToShip from './hooks/useReadyToShip'

import NoOrders from './NoOrders'
import Shipment from './Shipment'
import styles from './Orders.style'

const Orders = () => {
    const classes = useStyles(styles)
    const { t } = useTranslation()
    const { location } = useLocationContext()
    const {
        data,
        isLoading,
        error,
        isStale,
        isFetching,
    } = useReadyToShip(location.locationId)

    if (error) {
        throw error
    }

    const items = useMemo(() => {
        return data
    }, [data])

    const dataReady = useMemo(() => {
        return !isLoading && (isStale && !isFetching)
    }, [
        isLoading,
        isStale,
        isFetching,
    ])

    if (items && items.length === 0) {
        return (<NoOrders />)
    }

    return (
        <div css={classes.root}>
            <div css={classes.main}>
                { items && (
                    items.map((item) => {
                        return (
                            <Shipment
                                key={item.id}
                                orderNumber={item.orderNumber}
                                orderStatus={item.orderStatus}
                                plannedPickup={item.plannedPickup}
                                containers={item.containers}
                            />
                        )
                    })
                )}
                { !dataReady && (<Loading />)}
                <div css={classes.bottom}>
                    <Button
                        data-testid="back-button"
                        component={Link}
                        to="/mainDashboard"
                        css={classes.button}
                        startIcon={<ArrowBackIcon />}
                    >
                        {t('BACK')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Orders
